// extracted by mini-css-extract-plugin
module.exports = {"footer":"PvPrintButton_footer__1baUM"};